import React, { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { Button, Grid, Stack } from '@mui/material';


import { CustomCheckBox, CustomTextBox, CustomTextEditor } from 'components/forms';
import { validationRule } from 'utils/global';
import { useToastMessage } from 'hooks';
import SectionLayout from 'layouts/SectionLayout';
import { services } from 'redux/services';
import { Save } from '@mui/icons-material';
import BulkMailPreview from './BulkMailPreview';
import { HoverLoader } from 'components';

const defaultTemp = '<p>Greetings!,</p>\n<p><em><span style=\"font-family: arial, helvetica, sans-serif;\">***************Write a mail here*********************</span></em></p>\n<p style=\"line-height: 1;\">Best Regards,</p>\n<p style=\"line-height: 1;\"><strong>Pillaxia</strong>,</p>\n<p style=\"line-height: 1;\"><a href=\"https://pillaxia.com/\" target=\"_blank\" rel=\"noopener\">www.pillaxia.com</a></p>';

const BulkMail: React.FC<any> = () => {
    const { toastMessage } = useToastMessage();

    const { handleSubmit, formState: { errors }, clearErrors, setValue, control, setError, reset } = useForm({ mode: 'all' });
    const { formatMessage } = useIntl();
    const [loading, setLoading] = useState(false);
    const [description, setDescription] = useState(defaultTemp)
    const [previewTemplate, setPreviewTemplate] = useState({
        subject: '',
        html: ''
    })

    function onSubmit(data: any) {
        setLoading(true);
        if (!description) { setError('description', { type: 'required' }); return; }
        services.viewBulkMail({
            subject: data.subject,
            description
        })
            .then((res: any) => {
                setPreviewTemplate(res?.result)
            })
            .catch((err: any) => {
                toastMessage(JSON.stringify(err?.data?.message) || "Something wrong !", 'error');
            }).finally(() => setLoading(false))
    }

    function handleSendBulkMail() {
        setLoading(true);
        services.sendBulkMail({
            subject: previewTemplate.subject,
            description
        })
            .then((res: any) => {
                reset();
                setPreviewTemplate({
                    subject: '',
                    html: ''
                })
                setDescription(defaultTemp);
                toastMessage(formatMessage({ id: 'send-message' }, { title: formatMessage({ id: 'mail' }) }));
            })
            .catch((err: any) => {
                toastMessage(JSON.stringify(err?.data?.message) || "Something wrong !", 'error');
            }).finally(() => setLoading(false))
    }

    return (<Fragment>
        <SectionLayout title={'Promotions'}>
            {loading && <HoverLoader />}
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <CustomTextBox
                        label={formatMessage({ id: "subject" })}
                        name="subject"
                        control={control}
                        error={errors?.subject}
                        rules={validationRule.textbox({ required: true })}
                    />
                </Grid>

                <Grid item xs={12}>
                    <CustomTextEditor
                        name="description"
                        defaultValue={description}
                        onChange={(value) => { setDescription(value); clearErrors('description') }}
                        error={errors?.description}
                    />
                </Grid>

                {/* <Grid item xs={12}>
                    <CustomCheckBox
                        name="status"
                        label={formatMessage({ id: "is-active" })}
                        control={control}
                    />
                </Grid> */}
            </Grid>
            <Stack direction="row" alignItems="center" justifyContent="flex-end" my={1}>
                <Button variant="contained" type='submit' onClick={handleSubmit(onSubmit)} startIcon={<Save />}>
                    Submit
                </Button>
            </Stack>
            {previewTemplate.html && <BulkMailPreview
                open={true}
                closeModal={() => setPreviewTemplate({
                    subject: '',
                    html: ''
                })}
                headerText={'Promotions Mail'}
                previewTemplate={previewTemplate}
                handleSendBulkMail={handleSendBulkMail}
            />}
        </SectionLayout>
    </Fragment>
    )
}

export default BulkMail;